import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesLeft, faAnglesRight } from '@fortawesome/free-solid-svg-icons';

const PaginationSkeleton = () => {
  // Buttons distribution: initial numbers, active button, ellipsis, final number
  const pageSkeletons = [1, 'active', 2];

  return (
    <div className="flex justify-center mt-4">
      <div className="flex items-center space-x-2 bg-white py-3 pl-6 pr-6 rounded-md shadow-md">
        {/* "First" Button */}
        <div className=" h-6 text-gray-300 animate-pulse text-center flex items-center justify-center font-bold">
          <FontAwesomeIcon size="xs" icon={faAnglesLeft} />
        </div>

        {/* "Prev" Button */}
        <div className="w-12 h-6 bg-gray-300 rounded-md animate-pulse"></div>

        {/* Initial pages numbers */}
        {pageSkeletons.map((page, index) =>
          page === 'active' ? (
            <div
              key={index}
              className="w-6 h-6 bg-sky-400 rounded-md animate-pulse text-center flex items-center justify-center"
            ></div>
          ) : (
            <div
              key={index}
              className="w-6 h-6 bg-gray-300 rounded-md animate-pulse text-center flex items-center justify-center"
            ></div>
          ),
        )}

        {/* Ellipsis */}
        <div className="text-gray-300 font-bold flex items-center justify-center">...</div>

        {/* Page number after ellipsis */}
        <div className="w-6 h-6 bg-gray-300 rounded-md animate-pulse text-center flex items-center justify-center"></div>

        {/* "Next" Button */}
        <div className="w-12 h-6 bg-gray-300 rounded-md animate-pulse"></div>

        {/* "Last" Button */}
        <div className=" h-6 text-gray-300 animate-pulse text-center flex items-center justify-center font-bold">
          <FontAwesomeIcon size="xs" icon={faAnglesRight} />
        </div>
      </div>
    </div>
  );
};

export default PaginationSkeleton;
